<template>
  <v-form
    :style="{ position: 'relative' }"
    @submit.prevent="save()"
  >
    <v-card>
      <v-card-title>
        {{ $t('details') }}
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-text-field
          v-model="item.data.email"
          :error-messages="errorsByField.email"
          :label="$t('email')"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          color="secondary"
          text
          type="submit"
        >
          {{ $t('update') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <Overlay
      v-if="isLoading"
    />
  </v-form>
</template>

<script>
import errorHandlerMixin from '@/mixins/errorHandlerMixin'
import Overlay from '@/components/Overlay'

export default {
  name: 'AccountDetailsView',

  components: {
    Overlay,
  },

  mixins: [
    errorHandlerMixin,
  ],

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  metaInfo () {
    return {
      title: this.$t('details'),
    }
  },

  data () {
    return {
      isLoading: false,
    }
  },

  methods: {
    async save () {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      try {
        await this.item.request().save()
        this.clearErrors()
        this.$notify('success', this.$t('update_success'))
      } catch (e) {
        await this.handleException(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
